import { css } from "@emotion/react";

export const useStyles = (props) => ({
    floatingDiv: css({
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 0 5px 1px #d0d0d0",
        overflow: "hidden",
    }),
    floatingDivBarBottom: css({
        height: "50px",
    }),
    floatingDivContent: css({
        overflow: "auto",
        position: "relative",
        padding: "20px",
    }),
    greenButton: css({
        backgroundColor: "#39af81",
        width: "100% !important",
        height: "50px !important",
        color: "white !important",
        fontSize: "16px !important",
        borderRadius: "0 !important",
        textTransform: "none",
    }),
    redButton: css({
        backgroundColor: "#f1675e",
        width: "100% !important",
        height: "50px !important",
        color: "white !important",
        fontSize: "16px !important",
        borderRadius: "0 !important",
        textTransform: "none",
    }),
});
